import { render, staticRenderFns } from "./im-tabbar.vue?vue&type=template&id=52365b14&"
import script from "./im-tabbar.vue?vue&type=script&lang=js&"
export * from "./im-tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports